/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TenantService } from '@src/app/shared/tenant.service';
import { TenantId, uuid } from '@src/app/model/abstract-object';
import { BankAccount } from '@src/app/model/bankAccount';

export class BankOptionResponse {
    data: YapilyBankOption[];
    meta: {
        count: number,
        pagination: {
            totalCount: number,
        }
        tracingId: string;
    }
}
export class YapilyBankOption {
    id: string;
    name: string;
    fullName?: string;
    features?: string[];
    media?: {source: string, type:string}[];
}

export class YapilyAccount {
    yapilyAccountId: string;
    ourBankAccountName: string;
    type: string;
    IBAN: string;
    nickname: string;
    holder: string;
}

export class Consent {
    institutionId: string; // ties things together, one consent per institution per tenant
    institution: string; // The bank name
    id: uuid;
    consentId: string;
    userUuid: string;
    applicationUserId: TenantId;
    status: string;
    createdAt: string; //"2021-03-04T11:05:17.234Z"
    featureScope: string[];
    state: string; //"e539228113de43b3a3d4c3b9944620d3",
    institutionConsentId: string; // "aac-74e55df8-a673-48b4-b8ae-3e8d0e45080f",
    authorisationUrl: string; // "{authorisationUrl}",
    qrCodeUrl: string; //"https://images.yapily.com/image/d4113d96-9d6c-4e69-a840-2e327cff1b1d/1614855917?size=0"
    consent: string;
}

@Injectable({
    providedIn: 'root'
})
export class YapilyOpenBankingService {
    protected http = inject(HttpClient);

    protected get baseUrl() : string {
        return TenantService.ajaxPath + 'yapily';
    }

    requestAccess(bo: YapilyBankOption) {
        return this.http.post<Consent>(this.baseUrl + '/access', { bankId: bo.id, bankName: bo.name })
    }

    getBanks() {
        return this.http.get<BankOptionResponse>(this.baseUrl + '/banks');
    }
    connectBank(parms: {bankId: uuid, yapilyAccountId: string, consentId: string}) {
        return this.http.post<BankAccount>(this.baseUrl + '/connectBank', parms);
    }

    getConsents() {
        return this.http.get<Consent[]>(this.baseUrl + '/consents');
    }

    removeAccess(consent: Consent) {
        return this.http.delete<Consent>(this.baseUrl + '/consent/' + consent.consentId);
    }

    testAccess(consent: Consent){
        return this.http.post<{ accounts: number, description: string }>(this.baseUrl + '/test/' + consent.id, {});
    }

    consentApproved(consent: Partial<Consent>) {
        const url = this.baseUrl + '/consentApproved';
        return this.http.post<Consent[]>(url, consent);
    }

}
